import { makeLazyComponent } from '../../../utils/lazy';

export const LazySecondFactor = makeLazyComponent(
  async () =>
    (await import(/* webpackChunkName: "2fa" */ './SecondFactorComponent')).SecondFactorComponent,
);
